import { customFieldRepository } from '@webapp/core/data-access/repositories/CustomFieldRepository/CustomFieldRepository'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'

const base = ['customFields']

export const customFieldQueryConfig = {
  getAPItemCustomFields: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'apItem']),
    queryFn: () => customFieldRepository.getAPItemCustomFields(params),
  }),
  getSpendingCardCustomFields: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'spendingCard']),
    queryFn: () => customFieldRepository.getSpendingCardCustomFields(params),
  }),
  // Query: ['customFields', 'orderItem', 'list', params]
  // Invalidation prefix (no args): ['customFields', 'orderItem', 'list']
  getOrderItemList: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'orderItem', 'list', params]),
    queryFn: () => customFieldRepository.getOrderItemCustomFields(params),
  }),
  /** Base-key member for invalidation — matches every PO custom-field query */
  allPurchaseOrder: () => ({
    queryKey: buildQueryKey([...base, 'purchaseOrder']),
  }),
  // Query: ['customFields', 'purchaseOrder', 'list', params]
  // Invalidation prefix: allPurchaseOrder() → ['customFields', 'purchaseOrder']
  getPurchaseOrderCustomFields: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'purchaseOrder', 'list', params]),
    queryFn: () => customFieldRepository.getPurchaseOrderCustomFields(params),
  }),
  // Approval-routing groups deleted when the given field is disabled.
  getApprovalRoutingGroups: (customFieldId: number) => ({
    queryKey: buildQueryKey([...base, 'approvalRoutingGroups', customFieldId]),
    queryFn: () =>
      customFieldRepository.getApprovalRoutingGroups(customFieldId),
  }),
}
